import React, { useContext } from "react";
import AppContext from "../../AppContext";
import Address from "../Address";
import { metaMask } from "../../wallet/metamask";
import { walletConnect } from "../../wallet/walletconnect";

const WalletAddress = (props) => {
	const { walletChoice } = useContext(AppContext);

	const { walletAddress, classes, setWalletChoice } = props;
	return (
		<div
			onClick={async () => {
				if (walletChoice === "walletconnect") {
					await walletConnect.deactivate();
				} else if (walletChoice === "metamask") {
					await metaMask.deactivate();
				}
				window.location.reload();
				setWalletChoice("");
			}}
			className="cursor-pointer m-auto lg:m-0">
			<Address
				text={`${walletAddress.slice(0, 5)}...${walletAddress.slice(-3)}`}
				classes={classes}
			/>
		</div>
	);
};

export default WalletAddress;
